import {
  Avatar,
  Divider,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  MenuItem,
  Popover,
  Select,
  TextField,
  InputAdornment,
} from '@material-ui/core';

import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@material-ui/core/styles';
import { ExitToApp, Security } from '@material-ui/icons';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { LOGOUT, USER } from '../../constants/CommonConst';
import { languages } from '../../constants/LanguageConst';
import {
  FILTER_TYPE_BRAND,
  FILTER_TYPE_GROUP,
  FILTER_TYPE_HOTEL,
} from '../../constants/PropertyConst';
import {
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
  RBAC_TYPE_CMS_CITY_GUIDE,
  RBAC_TYPE_CMS_FEEDBACK,
  RBAC_TYPE_CMS_OFFERS,
  RBAC_TYPE_CMS_OFFER_CARDS,
  RBAC_TYPE_CMS_TVCHANNELS,
  RBAC_TYPE_DASHBOARD_ACCOMODATION,
  RBAC_TYPE_DASHBOARD_IRD,
  RBAC_TYPE_DASHBOARD_SERVICE_REQUEST,
  RBAC_TYPE_DASHBOARD_SPA,
  RBAC_TYPE_DESIGN_CONFIGS,
  RBAC_TYPE_EMAIL_SERVICES,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
  RBAC_TYPE_HOTEL_AMENITIES,
  RBAC_TYPE_HOTEL_LOCATION,
  RBAC_TYPE_HOTEL_RESTAURANT,
  RBAC_TYPE_HOTEL_SPA,
  RBAC_TYPE_HOTEL_SYSTEMS,
  RBAC_TYPE_NOTIFICATIONS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
  RBAC_TYPE_SERVICES_TELEPHONY,
  RBAC_TYPE_VENDOR_CONFIGS,
} from '../../constants/RoleConsts';
import {
  fetchAllBouquets,
  fetchAllCategorys,
  fetchAllChannels,
  fetchAllCityGuide,
  fetchAllFeedback,
  fetchAllOffers,
  fetchChannelNumberList,
  fetchAllOfferCards,
  fetchActivityList,
} from '../../layouts/cms/cmsSlice';
import {
  fetchAllDashboardIrdList,
  fetchHousekeepingOrdersList,
  fetchOccupancyBookings,
  fetchOccupancyCheckinList,
  fetchOccupancyOrdersList,
  fetchSpaDashboardOrderList,
} from '../../layouts/home/DashboardSlice';
import {
  allGroupsSelector,
  allBrandsSelector,
  allHotelsSelector,
  fetchAllAccommodations,
  fetchAllAmenities,
  fetchAllLocations,
  fetchAllProperties,
  fetchAllRestaurant,
  fetchAllSpa,
  fetchAllUIBuilderFlows,
  fetchAllUIBuilderHamburgerMenu,
  fetchAllUIBuilderHotelModuleOptions,
  fetchAllUIBuilderMenu,
  fetchAllUIBuilderPages,
  filteredBrandsSelector,
  filteredGroupsSelector,
  filteredHotelsSelector,
  selectedBrandSelector,
  selectedGroupSelector,
  selectedHotelSelector,
  setAllBrands,
  setAllGroups,
  setAllHotels,
  setSelectedBrand,
  setSelectedGroup,
  setSelectedHotel,
  menuConfigSelectedRestaurantSelector,
  allRestaurantSelector,
  uiBuilderEditModeStatueSelector,
  fetchAllPropertyConfigData,
} from '../../layouts/property/propertySlice';
import {
  fetchAllEmailServices,
  fetchAllInRoomDining,
  fetchAllInRoomDiningMenu,
  fetchAllNotifications,
  fetchAllServiceReqeust,
  fetchAllTelephonyDetails,
} from '../../layouts/services/servicesSlice';
import { checkAuthState } from '../../utils/APIUtils';
import {
  decryptLocalStorage,
  decryptSessionStorage,
  encryptLocalStorage,
  encryptSessionStorage,
  handleLogout,
} from '../../utils/authUtils';
import { notificationManager } from '../../utils/NotificationUtils';
import { getAccessControl } from '../../utils/RBACUtil';
import {
  fetchHotelSystemSettings,
  fetchIntegrationConfigs,
  fetchIntegrationStatus,
  fetchTelephonyConfigurator,
  fetchTelephonyEpbxList,
  fetchVendors,
} from './../../layouts/configurations/configurationSlice';
import './Header.scss';
import { setInitialAppStatusData } from '../../layouts/analytics/AnalyticsSlice';
import { handleSearchData } from '../../utils/formUtils';
import Loader from '../loader/Loader';
import { ENVIRONMENT } from '../../env/Configurations';
import { useLocation } from 'react-router-dom';
import { FNB_ORDERS, HOUSEKEEPING, OCCUPANCY, SPA } from '../../constants/DashboardConst';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  smallAvatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: 'pointer',
    backgroundColor: '#076c21',
  },
  largeAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: '#076c21',
  },
}));

const Header = ({ setLoading, activeTab }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const date = new Date();
  const classes = useStyles();
  const originalGroups = useSelector(allGroupsSelector);
  const originalHotels = useSelector(allHotelsSelector);
  const originalBrands = useSelector(allBrandsSelector);
  const filteredGroupList = useSelector(filteredGroupsSelector);
  const filteredBrandList = useSelector(filteredBrandsSelector);
  const filteredHotelList = useSelector(filteredHotelsSelector);
  const selectedGroupItem = useSelector(selectedGroupSelector);
  const selectedBrandItem = useSelector(selectedBrandSelector);
  const selectedHotelItem = useSelector(selectedHotelSelector);
  const selectedRestaurant = useSelector(menuConfigSelectedRestaurantSelector);
  const allRestaurants = useSelector(allRestaurantSelector);
  const isUiBuilderEditMode = useSelector(uiBuilderEditModeStatueSelector);
  const [anchorEl, setAnchorEl] = useState(null);
  const loggedinUser = decryptLocalStorage(USER);
  const [userRolePermissions, setUserRolePermissions] = useState(null);
  const [cognitoUser, setCognitoUser] = useState(null);
  const [language, setLanguage] = useState(() => decryptLocalStorage('lang') ?? 'en');
  const [isCulinaryOperationManager, setIsCulinaryOperationManager] = useState(false);
  const selectedHotelDetails = originalHotels?.find((hotel) => hotel?.id === selectedHotelItem);
  const [hotelSearchQuery, setHotelSearchQuery] = useState('');
  const [filteredHotels, setFilteredHotels] = useState(filteredHotelList);
  const [brandSearchQuery, setBrandSearchQuery] = useState('');
  const [filteredBrands, setFilteredBrands] = useState(filteredBrandList);
  const [groupSearchQuery, setGroupSearchQuery] = useState('');
  const [filteredGroups, setFilteredGroups] = useState(filteredGroupList);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    encryptLocalStorage('lang', language);
  }, [language]);

  useEffect(() => {
    setIsSuperAdmin(cognitoUser && cognitoUser['custom:role'] === 'SUPER_ADMIN');
  }, [cognitoUser]);

  useEffect(() => {
    if (!hotelSearchQuery) {
      setFilteredHotels(filteredHotelList);
    }
    if (!groupSearchQuery) {
      setFilteredGroups(filteredGroupList);
    }
    if (!brandSearchQuery) {
      setFilteredBrands(filteredBrandList);
    }
  }, [
    filteredHotelList,
    filteredGroupList,
    filteredBrandList,
    hotelSearchQuery,
    groupSearchQuery,
    brandSearchQuery,
  ]);

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      setCognitoUser(currUser?.attributes);
      if (
        currUser &&
        currUser?.attributes &&
        currUser?.attributes['custom:role'] === 'CULINARY_OPERATIONS_MANAGER'
      ) {
        setIsCulinaryOperationManager(true);
      }
    })();
  }, []);

  useEffect(() => {
    dispatch(fetchAllProperties());
    if (selectedHotelItem) {
      dispatch(fetchAllPropertyConfigData(selectedHotelItem));
      if (userRolePermissions && userRolePermissions[RBAC_TYPE_CMS_OFFERS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS) {
        if (location?.pathname === '/offers') {
          dispatch(fetchAllOffers(selectedHotelItem));
          dispatch(fetchAllOfferCards(selectedHotelItem));
        }
      }
    }
  }, [language, selectedHotelItem, userRolePermissions, location?.pathname]);

  useEffect(() => {
    if (!userRolePermissions) {
      (async () => {
        try {
          const perms = await getAccessControl();
          setUserRolePermissions(perms);
        } catch (error) {
          if (ENVIRONMENT === 'dev') {
            console.log(error?.message);
          }
        }
      })();
    }
  }, [userRolePermissions]);

  useEffect(() => {
    if (cognitoUser && cognitoUser['custom:role'] !== 'SUPER_ADMIN') {
      if (filteredGroupList?.length > 0 && !selectedGroupItem) {
        dispatch(
          setSelectedGroup(decryptSessionStorage('selectedGroup') || filteredGroupList?.[0]?.id),
        );
      }
      if (filteredBrandList?.length > 0 && !selectedBrandItem) {
        dispatch(
          setSelectedBrand(decryptSessionStorage('selectedBrand') || filteredBrandList?.[0]?.id),
        );
      }
      if (filteredHotelList?.length > 0 && !selectedHotelItem) {
        dispatch(
          setSelectedHotel(decryptSessionStorage('selectedHotel') || filteredHotelList?.[0]?.id),
        );
      }
    }

    if (cognitoUser && cognitoUser['custom:role'] === 'SUPER_ADMIN') {
      if (filteredGroupList?.length > 0 && !selectedGroupItem) {
        dispatch(setSelectedGroup(decryptSessionStorage('selectedGroup') || ''));
      }
      if (filteredBrandList?.length > 0 && !selectedBrandItem) {
        dispatch(setSelectedBrand(decryptSessionStorage('selectedBrand') || ''));
      }
      if (filteredHotelList?.length > 0 && !selectedHotelItem) {
        dispatch(setSelectedHotel(decryptSessionStorage('selectedHotel') || ''));
      }
    }
  }, [originalGroups, originalBrands, originalHotels, cognitoUser]);

  useEffect(() => {
    if (!selectedHotelItem || !userRolePermissions) return;

    if (
      userRolePermissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      (location?.pathname === '/accommodations' ||
        location?.pathname === '/tvchannels' ||
        location?.pathname === '/devices')
    ) {
      dispatch(fetchAllAccommodations(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_HOTEL_AMENITIES] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/amenities'
    ) {
      dispatch(fetchAllAmenities(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_HOTEL_LOCATION] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      (location?.pathname === '/location' ||
        location?.pathname === '/tvchannels' ||
        location?.pathname === '/devices')
    ) {
      dispatch(fetchAllLocations(selectedHotelItem));
      if (location?.pathname === '/location') {
        dispatch(fetchAllBouquets(selectedHotelItem));
        dispatch(fetchActivityList(selectedHotelItem));
      }
    }
    if (
      userRolePermissions[RBAC_TYPE_HOTEL_RESTAURANT] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      (location?.pathname === '/restaurant' ||
        location?.pathname === '/' ||
        location?.pathname === '/in-room-dining')
    ) {
      dispatch(fetchAllRestaurant(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/service-request'
    ) {
      dispatch(fetchAllServiceReqeust(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_HOTEL_SPA] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/spa'
    ) {
      dispatch(fetchAllSpa(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_VENDOR_CONFIGS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/vendor-config'
    ) {
      dispatch(fetchVendors(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_CMS_OFFERS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/offers'
    ) {
      dispatch(fetchAllOffers(selectedHotelItem));
      dispatch(fetchAllOfferCards(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_CMS_TVCHANNELS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/tvchannels'
    ) {
      dispatch(fetchAllBouquets(selectedHotelItem));
      dispatch(fetchAllChannels(selectedHotelItem));
      dispatch(fetchAllCategorys(selectedHotelItem));
      dispatch(fetchChannelNumberList(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_SERVICES_TELEPHONY] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/telephony'
    ) {
      dispatch(fetchAllTelephonyDetails(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_NOTIFICATIONS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/notifications'
    ) {
      dispatch(fetchAllNotifications(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_EMAIL_SERVICES] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/email-services'
    ) {
      dispatch(fetchAllEmailServices(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_CMS_CITY_GUIDE] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/city-guide'
    ) {
      dispatch(fetchAllCityGuide(selectedHotelItem));
    }
    if (
      userRolePermissions[RBAC_TYPE_CMS_FEEDBACK] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/feedback-cms'
    ) {
      dispatch(fetchAllFeedback(selectedHotelItem));
    }
    if (
      selectedHotelDetails?.isUIBuilderEnabled &&
      userRolePermissions[RBAC_TYPE_DESIGN_CONFIGS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      (location?.pathname === '/ui-builder' || location?.pathname === '/offers')
    ) {
      dispatch(fetchAllUIBuilderPages(selectedHotelItem));
      dispatch(fetchAllUIBuilderMenu(selectedHotelItem));
      dispatch(fetchAllUIBuilderFlows());
      dispatch(fetchAllUIBuilderHotelModuleOptions(selectedHotelItem));
      dispatch(fetchAllUIBuilderHamburgerMenu(selectedHotelItem));
      if (location?.pathname === '/ui-builder') {
        dispatch(fetchAllRestaurant(selectedHotelItem));
        dispatch(fetchAllOffers(selectedHotelItem));
        dispatch(fetchAllSpa(selectedHotelItem));
        dispatch(fetchAllAmenities(selectedHotelItem));
        dispatch(fetchAllAccommodations(selectedHotelItem));
      }
    }

    if (
      activeTab === FNB_ORDERS &&
      userRolePermissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] !== RBAC_PERMISSION_LEVEL_NO_ACCESS
    ) {
      const selectedRestaurantId =
        isCulinaryOperationManager && allRestaurants.length
          ? allRestaurants[0].id
          : selectedRestaurant?.id || '';
      dispatch(fetchAllInRoomDining(selectedHotelItem, selectedRestaurantId));
      dispatch(fetchAllInRoomDiningMenu(selectedHotelItem, selectedRestaurantId));
    }
    // if (
    //   activeTab === SPA &&
    //   userRolePermissions[RBAC_TYPE_DASHBOARD_SPA] !== RBAC_PERMISSION_LEVEL_NO_ACCESS
    // ) {
    //   dispatch(fetchSpaDashboardOrderList(selectedHotelItem));
    // }
    // if (
    //   activeTab === HOUSEKEEPING &&
    //   userRolePermissions[RBAC_TYPE_DASHBOARD_SERVICE_REQUEST] !== RBAC_PERMISSION_LEVEL_NO_ACCESS
    // ) {
    //   dispatch(fetchHousekeepingOrdersList(selectedHotelItem));
    // }
    if (
      activeTab === OCCUPANCY &&
      userRolePermissions[RBAC_TYPE_DASHBOARD_ACCOMODATION] !== RBAC_PERMISSION_LEVEL_NO_ACCESS
    ) {
      dispatch(fetchOccupancyOrdersList(selectedHotelItem));
      dispatch(fetchOccupancyCheckinList(selectedHotelItem));
      dispatch(fetchOccupancyBookings(selectedHotelItem));
    }

    if (
      userRolePermissions[RBAC_TYPE_HOTEL_SYSTEMS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS &&
      location?.pathname === '/hotel-service'
    ) {
      dispatch(fetchTelephonyEpbxList());
      dispatch(fetchTelephonyConfigurator(selectedHotelItem));
      dispatch(fetchIntegrationStatus(selectedHotelItem));
      dispatch(fetchHotelSystemSettings(selectedHotelItem));
      dispatch(fetchIntegrationConfigs('config'));
      dispatch(fetchIntegrationConfigs('map'));
    }
  }, [
    selectedHotelItem,
    userRolePermissions,
    language,
    selectedRestaurant,
    location?.pathname,
    activeTab,
  ]);

  const [ssoLoggingOut, setSsoLoggingOut] = useState(false);

  const logout = async () => {
    try {
      const logOut = localStorage.getItem(LOGOUT);
      handleUserMenuClose();
      if (logOut) {
        setSsoLoggingOut(true);

        sessionStorage.clear();
        localStorage.setItem('logout_signal', 'true');
        localStorage.removeItem('user');
        localStorage.removeItem('lang');
        localStorage.removeItem(LOGOUT);
        Object.keys(localStorage)
          .filter((k) => k.includes('CognitoIdentityServiceProvider'))
          .forEach((k) => localStorage.removeItem(k));

        const logoutPopup = window.open(
          'https://login.microsoftonline.com/common/wsfederation?wa=wsignout1.0',
          'sso_logout',
          'width=500,height=600'
        );
        if (logoutPopup) {
          await new Promise((resolve) => {
            setTimeout(() => {
              try { logoutPopup.location = logOut; } catch (e) {}
            }, 2000);

            const pollTimer = setInterval(() => {
              try {
                if (logoutPopup.closed) {
                  clearInterval(pollTimer);
                  resolve();
                  return;
                }
                if (logoutPopup.location?.origin === window.location.origin) {
                  clearInterval(pollTimer);
                  logoutPopup.close();
                  resolve();
                }
              } catch (e) {
              }
            }, 500);
            setTimeout(() => {
              clearInterval(pollTimer);
              try { if (!logoutPopup.closed) logoutPopup.close(); } catch (e) {}
              resolve();
            }, 15000);
          });
        }

        localStorage.removeItem('logout_signal');
        sessionStorage.setItem('logout_success', 'true');
        window.location.replace('/prelogin');
      } else {
        sessionStorage.clear();
        localStorage.setItem('logout_signal', 'true');
        handleLogout(history, true);
        dispatch(setAllGroups([]));
        dispatch(setAllBrands([]));
        dispatch(setAllHotels([]));
      }
    } catch (error) {
      notificationManager('danger', 'Unable to remove user lock');
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }
      handleUserMenuClose();
    }
  };

  const copyAPIKeyToClipboard = () => {
    const idTokenKey = Object.keys(localStorage)?.find((key) => key?.includes('idToken'));
    if (!idTokenKey) {
      notificationManager('danger', 'Invalid user session, API key not found');
      return;
    }

    const token = localStorage.getItem(idTokenKey);
    if (!token) {
      notificationManager('danger', 'Unable to locate API key');
      return;
    }

    navigator?.clipboard?.writeText(token).then(
      () => {
        notificationManager('success', 'API key successfully copied to clipboard');
      },
      (error) => {
        notificationManager('danger', 'Unable to copy API key to clipboard');
        if (ENVIRONMENT === 'dev') {
          console.log(error?.message);
        }
      },
    );
  };

  const handleFilterChange = (event) => {
    dispatch(setInitialAppStatusData());
    switch (event?.target?.name) {
      case FILTER_TYPE_GROUP:
        dispatch(setSelectedGroup(event?.target?.value));
        dispatch(setSelectedBrand(''));
        dispatch(setSelectedHotel(''));
        encryptSessionStorage('selectedGroup', event?.target?.value);
        encryptSessionStorage('selectedBrand', '');
        encryptSessionStorage('selectedHotel', '');
        history.push('/properties');
        break;
      case FILTER_TYPE_BRAND:
        if (event?.target?.value) {
          const brandObj = originalBrands?.find((brand) => brand?.id === event?.target?.value);
          const groupId = brandObj?.groupId || '';
          dispatch(setSelectedGroup(groupId));
          dispatch(setSelectedBrand(event?.target?.value));
          encryptSessionStorage('selectedGroup', groupId);
          encryptSessionStorage('selectedBrand', event?.target?.value);
        } else {
          encryptSessionStorage('selectedBrand', '');

          dispatch(setSelectedBrand(''));
        }
        dispatch(setSelectedHotel(''));
        encryptSessionStorage('selectedHotel', '');

        history.push('/properties');

        break;
      case FILTER_TYPE_HOTEL:
        if (event?.target?.value) {
          const hotelObj = originalHotels?.find((hotel) => hotel?.id === event?.target?.value);
          const brandId = hotelObj?.brandId || '';
          const groupId = hotelObj?.groupId || '';
          encryptSessionStorage('selectedGroup', groupId);
          encryptSessionStorage('selectedBrand', brandId);

          dispatch(setSelectedGroup(groupId));
          dispatch(setSelectedBrand(brandId));
        } else {
          history.push('/properties');
        }
        dispatch(setSelectedHotel(event?.target?.value));
        encryptSessionStorage('selectedHotel', event?.target?.value);
        break;
      default:
        if (ENVIRONMENT === 'dev') {
          console.log(`Unknown filter type ${event?.target?.name}`);
        }
        break;
    }
    setBrandSearchQuery('');
    setGroupSearchQuery('');
    setHotelSearchQuery('');
  };

  const handleUserMenuClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const userMenuOpen = Boolean(anchorEl);
  const id = userMenuOpen ? 'usermenu-popover' : undefined;
  const [anchorElLang, setAnchorElLang] = React.useState(null);

  const handleClick = (event) => {
    if (!isUiBuilderEditMode) {
      setAnchorElLang(event?.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorElLang(null);
  };

  const open = Boolean(anchorElLang);
  const langId = open ? 'simple-popover' : undefined;
  const flagImg = languages?.find((lang) => lang?.code === language)?.img;

  const setSelectedLanguage = (lang) => {
    setLoading(true);
    setLanguage(lang);
    handleClose();

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const handleSearchHotel = (e) => {
    handleSearchData(e, setHotelSearchQuery, setFilteredHotels, filteredHotelList);
  };

  const handleSearchBrand = (e) => {
    handleSearchData(e, setBrandSearchQuery, setFilteredBrands, filteredBrandList);
  };

  const handleSearchGroup = (e) => {
    handleSearchData(e, setGroupSearchQuery, setFilteredGroups, filteredGroupList);
  };

  const handleDropdownClose = (dropdownType) => {
    if (dropdownType === FILTER_TYPE_HOTEL) {
      setHotelSearchQuery('');
    } else if (dropdownType === FILTER_TYPE_BRAND) {
      setBrandSearchQuery('');
    } else {
      setGroupSearchQuery('');
    }
  };

  if (ssoLoggingOut) {
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999, backgroundColor: '#fff' }}>
        <Loader />
      </div>
    );
  }

  return (
    <div
      className='col-auto header m-0 py-0 d-flex justify-content-between flex-wrap'
      bg='light'
      expand='lg'
    >
      <div className='col d-flex flex-wrap align-items-center property-filter showpopup py-1'>
        <FormControl className={classes?.formControl}>
          <InputLabel id='group-select-label' shrink={false}>
            Group
          </InputLabel>
          <Select
            labelId='group-select-label'
            id='group-select'
            className='showpopup'
            name={FILTER_TYPE_GROUP}
            value={selectedGroupItem}
            onChange={handleFilterChange}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
              disableAutoFocusItem: true,
            }}
            onClose={handleDropdownClose}
          >
            {isSuperAdmin && (
              <ListSubheader className='custom-search-text'>
                {filteredGroups?.length > 0 && (
                  <TextField
                    value={groupSearchQuery}
                    fullWidth
                    options={filteredGroupList}
                    placeholder={'Select Group'}
                    onChange={(e) => {
                      handleSearchGroup(e);
                    }}
                    className='custom-search-input'
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    onClick={(e) => {
                      e?.stopPropagation();
                    }}
                    onKeyDown={(e) => {
                      if (e?.key !== 'Escape') {
                        e?.stopPropagation();
                      }
                    }}
                  />
                )}
              </ListSubheader>
            )}
            {!filteredGroups?.length ? (
              <MenuItem value={''}>No Groups Found</MenuItem>
            ) : (
              isSuperAdmin && <MenuItem value={''}>None</MenuItem>
            )}
            {(isSuperAdmin ? filteredGroups : filteredGroupList)?.map((group, i) => (
              <MenuItem key={i} value={group?.id}>
                {group?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <span className='separator'>/</span>
        <FormControl className={classes?.formControl}>
          <InputLabel id='brand-select-label' shrink={false}>
            Brand
          </InputLabel>
          <Select
            labelId='brand-select-label'
            id='brand-select'
            className='showpopup'
            name={FILTER_TYPE_BRAND}
            value={selectedBrandItem}
            onChange={handleFilterChange}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
              disableAutoFocusItem: true,
            }}
            onClose={() => handleDropdownClose(FILTER_TYPE_BRAND)}
          >
            <ListSubheader className='custom-search-text'>
              {filteredBrands?.length > 0 && (
                <TextField
                  value={brandSearchQuery}
                  fullWidth
                  options={filteredBrandList}
                  placeholder={'Select Brand'}
                  onChange={(e) => {
                    handleSearchBrand(e);
                  }}
                  className='custom-search-input'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onClick={(e) => {
                    e?.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    if (e?.key !== 'Escape') {
                      e?.stopPropagation();
                    }
                  }}
                />
              )}
            </ListSubheader>
            {!filteredBrands?.length ? (
              <MenuItem value={''}>No Brands Found</MenuItem>
            ) : (
              isSuperAdmin && <MenuItem value={''}>None</MenuItem>
            )}
            {filteredBrands?.map((brand, i) => (
              <MenuItem key={i} value={brand?.id}>
                {brand?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <span className='separator'>/</span>
        <FormControl className={classes?.formControl}>
          <InputLabel id='hotel-select-label' shrink={false}>
            Hotel
          </InputLabel>
          <Select
            labelId='hotel-select-label'
            id='hotel-select'
            className='showpopup'
            name={FILTER_TYPE_HOTEL}
            value={selectedHotelItem}
            onChange={handleFilterChange}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
              disableAutoFocusItem: true,
            }}
            onClose={() => handleDropdownClose(FILTER_TYPE_HOTEL)}
          >
            <ListSubheader className='custom-search-text'>
              {filteredHotels?.length > 0 && (
                <TextField
                  value={hotelSearchQuery}
                  fullWidth
                  options={filteredHotelList}
                  placeholder={'Select Hotel'}
                  onChange={(e) => {
                    handleSearchHotel(e);
                  }}
                  className='custom-search-input'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onClick={(e) => {
                    e?.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    if (e?.key !== 'Escape') {
                      e?.stopPropagation();
                    }
                  }}
                />
              )}
            </ListSubheader>
            {!filteredHotels?.length ? (
              <MenuItem value={''}>No Hotels Found</MenuItem>
            ) : (
              isSuperAdmin && <MenuItem value={''}>None</MenuItem>
            )}
            {filteredHotels?.map((hotel, i) => (
              <MenuItem key={i} value={hotel?.id}>
                {hotel?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className='col-auto d-flex justify-content-between pe-3 my-0 align-items-center gap-3'>
        <div className='nav-info-item'>
          <i className='fa fa-calendar-o me-1'></i>
          <span>
            <Moment format='dddd, Do MMMM yyyy'>{date}</Moment>
          </span>
        </div>
        <div>
          <div
            onClick={handleClick}
            className={`d-flex align-items-center showpopup cursor-pointer`}
            style={isUiBuilderEditMode ? { pointerEvents: 'none' } : {}}
          >
            <img src={flagImg} alt='' width='35' className='showpopup' />
            {!anchorElLang ? (
              <KeyboardArrowDownIcon className='ms-2 ' />
            ) : (
              <KeyboardArrowUpIcon className='ms-2' />
            )}
          </div>
          <Popover
            className='mt-1 ms-3'
            id={langId}
            open={open}
            anchorEl={anchorElLang}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            {languages?.map((lang, i) => (
              <MenuItem key={i} className='pe-2' onClick={() => setSelectedLanguage(lang?.code)}>
                {lang?.name}
                {lang?.code === language && <CheckIcon className='ms-4 fs-6' />}
              </MenuItem>
            ))}
          </Popover>
        </div>
        <div className='nav-info-item'>
          <i className='fa fa-question-circle me-1'></i>
          <span>Help</span>
        </div>
        {/* // To be used in future. 
        {cognitoUser && cognitoUser["custom:role"] !== "SUPER_ADMIN" && (
          <div className="nav-info-item">
            <div className="notifications-icon">
              <i className="fa fa-bell"></i>
              <span className="notification-indicator"></span>
            </div>
          </div>
        )} */}

        <div className='nav-info-item'>
          <div className='d-flex'>
            {loggedinUser?.imageUrl ? (
              <Avatar
                alt={loggedinUser?.firstName}
                src={loggedinUser?.imageUrl}
                className={`showpopup ${classes?.smallAvatar}`}
                onClick={handleUserMenuClick}
              />
            ) : (
              <Avatar onClick={handleUserMenuClick} className={`showpopup ${classes?.smallAvatar}`}>
                {loggedinUser?.firstName && loggedinUser?.firstName?.[0]}
              </Avatar>
            )}
          </div>
          <Popover
            id={id}
            open={userMenuOpen}
            anchorEl={anchorEl}
            onClose={handleUserMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <div className='header-user-menu'>
              <div className='d-flex p-4'>
                {loggedinUser?.imageUrl ? (
                  <Avatar
                    alt='User profile'
                    src={loggedinUser?.imageUrl}
                    className={classes?.largeAvatar}
                  />
                ) : (
                  <Avatar className={classes?.largeAvatar}>
                    {loggedinUser?.firstName && loggedinUser?.firstName[0]}
                  </Avatar>
                )}
                <div className='ms-3 d-flex justify-content-center flex-column'>
                  <div className='header-user-menu-username'>
                    {loggedinUser?.firstName} {loggedinUser?.lastName}
                  </div>
                  {/*To be used in future.
                   <div className="header-user-menu-profile-link mt-1">
                    View Profile <i className="fa fa-angle-right"></i>
                  </div> */}
                </div>
              </div>
              <div className='header-user-menu-list'>
                <Divider />
                <List component='nav' aria-label='main user menu'>
                  <ListItem button onClick={(e) => copyAPIKeyToClipboard()}>
                    <ListItemIcon>
                      <ContentCopyRoundedIcon className='header-user-menu-icon-api-key-copy' />
                    </ListItemIcon>
                    <ListItemText primary='Copy API Key' />
                  </ListItem>
                  {/* <ListItem
                    button
                    onClick={() => {
                      handleUserMenuClose();
                      history.push('/mfa-setup');
                    }}
                  >
                    <ListItemIcon>
                      <Security color='primary' />
                    </ListItemIcon>
                    <ListItemText primary='MFA Setup' />
                  </ListItem> */}
                  <ListItem button onClick={(e) => logout()}>
                    <ListItemIcon>
                      <ExitToApp color='primary' />
                    </ListItemIcon>
                    <ListItemText primary='Logout' />
                  </ListItem>
                </List>
              </div>
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Header;
